/**
 * Props for the Pan slot component.
 * @public
 */
export interface TimeseriesPanSlotProps {
  /**
   * Whether the pan is disabled.
   */
  disabled?: boolean;
}

/**
 * Pan slot component.
 */
export const Pan = (props: TimeseriesPanSlotProps) => null;

Pan['displayName'] = 'TimeseriesChart.Pan';
